<template>
  <div>
    <div class="m-title">{{ conf.title || '无' }}</div>

    <div class="board-box" v-loading="loading">
      <select-range @range-change="rangeChange" />
      <div :id="chartId" class="chart1"></div>
    </div>
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 柱形图
 */
export default {
  mixins: [common],
  name: 'ChartBar3',
  props: {
    source: { String, default: '' }
  },
  data() {
    return {
      chartData: {}
    }
  },
  computed: {
    conf: function() {
      /**
       * 不同 source 下配置数据
       * - fieldConf 整理数据时，字段配置
       * - filedConf.filterField 品牌下拉字段
       */
      const Map = {
        request: {
          title: '各品牌各工单类型-服务请求数量',
          fieldConf: { mField: 'WORK_ORDER_TYPE_DESC', xField: 'BRAND_NAME', timeField: 'YW_WORK_ORDER_CREATE_TIME' }
        },
        scene: {
          title: '各品牌各工单类型-现场服务单数量',
          fieldConf: { mField: 'WORK_ORDER_TYPE_DESC', xField: 'BRAND_NAME', timeField: 'YW_SERVICE_ORDER_CREATE_TIME' }
        },
        remote: {
          title: '各品牌各工单类型-远程单数量',
          fieldConf: { mField: 'WORK_ORDER_TYPE_DESC', xField: 'BRAND_NAME', timeField: 'YW_WORK_ORDER_CREATE_TIME' }
          // fieldConf: { mock: true, mField: 'stage', xField: 'brand', timeField: 'YW_WORK_ORDER_CREATE_TIME' }
        }
      }

      return Map[this.source] || {}
    }
  },
  watch: {
    chartData: function() {
      this.updateChart()
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    updateChart: function() {
      let chartData = this.chartData,
        conf = this.conf
      let options = {
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: '20',
          top: '55',
          bottom: '20',
          data: chartData.legend
        },
        series: chartData.series,
        xAxis: [
          {
            type: 'category',
            triggerEvent: conf.triggerLabel,
            boundaryGap: true,
            data: chartData.xAxis || []
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '（个）',
            boundaryGap: [0.2, 0.2],
            min: 0,
            minInterval: 1
          }
        ],
        dataZoom: {
          show: true,
          start: 0,
          // end: 50,
          end: (10 * 100) / chartData.xAxis.length,
          height: 15
        },
        grid: { right: 130 },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        }
      }

      /** @type {import('echarts').ECharts} */
      let chartIns = this.chartIns
      chartIns && chartIns.setOption(options, true)
    },

    /**
     * 处理数据
     * @param {[]} list
     */
    processList: function(list) {
      let { mField, xField } = this.conf.fieldConf

      let series = [],
        xAxis = [],
        legend = [],
        total = 0

      let multiColMap = {},
        categoryMap = {}

      list.map(v => {
        let curX = v[xField],
          m = v[mField]

        /** 某个 legend：集成、改造等 */
        if (!multiColMap[m]) multiColMap[m] = true

        if (!categoryMap[curX]) categoryMap[curX] = {}
        if (!categoryMap[curX][m]) categoryMap[curX][m] = []

        categoryMap[curX][m].push(v)
      })
      legend = Object.keys(multiColMap)

      xAxis = Object.keys(categoryMap)
      series = legend.map(m => {
        let list = xAxis.map(curX => {
          let n = (categoryMap[curX][m] || []).reduce((total, cur) => (total += 1), 0)

          total += n
          return {
            name: [curX, m].join(','),
            value: n
          }
        })

        return {
          name: m,
          type: 'bar',
          stack: '广告',
          emphasis: {
            focus: 'series'
          },
          barMaxWidth: '14',
          data: list
        }
      })

      this.chartData = { legend, xAxis, series, total }
    },

    /**
     * 获取数据
     * @param {import('./SelectRange.vue').IRange} range 选择日期、品牌、工程师
     */
    getData: function(range) {
      let condition = this.condition,
        /** @type {import('../index.vue').IRoleId} */
        roleId = this.roleId,
        { mock, timeField } = this.conf.fieldConf,
        source = this.source

      if (range) {
        if (range.type === 'date') {
          const tf = 'YYYY-MM-DD'
          // 日期变化
          let [start = '', end = ''] = range.data.current
          if (start === end) {
            // LIKE
            condition[`${timeField}:2`] = start + '%'
          } else {
            // <= 接口不包含此临界值，故需 +1 或者拼接时分秒
            end = moment(end)
              .add(1, 'day')
              .format(tf)

            condition[`${timeField}:5`] = start
            condition[`${timeField}:6`] = end
          }
          if (!start && !end) {
            delete condition[`${timeField}:2`]
            delete condition[`${timeField}:5`]
            delete condition[`${timeField}:6`]
          }
        }
      }

      this.loading = true
      let requestFn = ''
      if (source === 'request') {
        requestFn = this.api.queryList('YW_WORK_ORDER_DETAIL_V1', { p2: condition, p9: '' }, `${roleId}_chart_4`)
      } else if (source === 'scene') {
        requestFn = this.api.queryList('YW_SERVICE_ORDER_V1', { p2: condition, p9: '' }, `${roleId}_chart_5`)
      } else if (source === 'remote') {
        condition['WORK_ORDER_METHOD:0'] = '2'
        requestFn = this.api.queryList('YW_WORK_ORDER_DETAIL_V1', { p2: condition, p9: '' }, `${roleId}_chart_6`)
      }
      requestFn.then(
        res => {
          this.loading = false
          let resData = (this.sourceList = res.result)

          // TODO: 模拟数据
          if (mock) {
            resData = this.sourceList = this.genTableData(100)
          }

          this.processList(resData)
        },
        err => {
          this.loading = false
        }
      )
    }
  }
}
</script>

<style lang="postcss"></style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartBar3.vue